// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"8cc133f0","64":"466804d1","406":"4184b777","495":"8ae9c869","496":"50174389","521":"a59c6d2a","631":"aa55794a"}[chunkId] + ".chunk.js";
};